import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function Categories() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const categories = [
    { icon: "ri-compass-3-line", label: t("cat_adventure_nature"), count: 7, key: "cat_adventure_nature" },
    { icon: "ri-building-4-line", label: t("cat_parks_tickets"), count: 6, key: "cat_parks_tickets" },
    { icon: "ri-sailboat-line", label: t("cat_boat_trips"), count: 4, key: "cat_boat_trips" },
    { icon: "ri-water-flash-line", label: t("cat_water_activities"), count: 2, key: "cat_water_activities" },
    { icon: "ri-music-2-line", label: t("cat_entertainment"), count: 2, key: "cat_entertainment" },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-accent-600 font-medium mb-3">{t("cat_title")}</span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-4">
            {t("cat_heading")}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            {t("cat_subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {categories.map((c) => (
            <a
              key={c.key}
              onClick={(e) => {
                e.preventDefault();
                navigate(`/excursions?category=${c.key}`);
              }}
              href={`/excursions?category=${c.key}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-300 hover:-translate-y-0.5 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-accent-100 group-hover:bg-accent-500 flex items-center justify-center mb-4 transition-colors">
                <i className={`${c.icon} text-2xl text-accent-700 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <div className="font-medium text-foreground-900 text-sm md:text-base mb-1">{c.label}</div>
              <div className="text-xs text-foreground-500">{c.count} {t("cat_activities")}</div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}